import { BAPTISM } from "./baptism";
import { INTERVIEW_SEGMENT } from "./interview-segment";
import { PRAYER } from "./prayer";
import { TALK_FROM_LECTERN } from "./talk-from-lectern";
import type { ControllableCam, Preset, Scenario, ScenarioId } from "./types";

// Single registry of scenarios available to the simulator. New scenarios land
// here as their masters ship, each with its own master photo and per-cam preset
// library. `AVAILABLE_SCENARIO_IDS` is the source of truth for the picker.
export const SCENARIOS: Partial<Record<ScenarioId, Scenario>> = {
  "interview-segment": INTERVIEW_SEGMENT,
  "talk-from-lectern": TALK_FROM_LECTERN,
  prayer: PRAYER,
  baptism: BAPTISM,
};

export const AVAILABLE_SCENARIO_IDS: ScenarioId[] = (
  Object.keys(SCENARIOS) as ScenarioId[]
).filter((id) => SCENARIOS[id] !== undefined);

export const DEFAULT_SCENARIO_ID: ScenarioId = "interview-segment";

export function getScenario(id: ScenarioId): Scenario {
  const scenario = SCENARIOS[id];
  if (!scenario) {
    throw new Error(`Unknown or unavailable scenario: ${id}`);
  }
  return scenario;
}

export function presetById(
  scenario: Scenario,
  cam: ControllableCam,
  presetId: string,
): Preset | null {
  return scenario.presets[cam].find((p) => p.id === presetId) ?? null;
}

export function defaultPresetFor(
  scenario: Scenario,
  cam: ControllableCam,
): Preset {
  const presetId = scenario.defaults[cam];
  const preset = presetById(scenario, cam, presetId);
  if (!preset) {
    throw new Error(
      `Scenario ${scenario.id} cam ${cam} default preset id ${presetId} not found in library.`,
    );
  }
  return preset;
}
